import React, { Component } from 'react'
import { Col, Row, Label } from 'reactstrap'
import Card from '../../../comum/components/Card'
import { inject, observer } from 'mobx-react'
import RadiobuttonGroup from '../../../comum/components/RadiobuttonGroup'
import CalendarioPicker from '../../../comum/components/Calendario'
import FormSelectSimples from '../../../comum/components/FormSelectSimples'
import FormInputSimples from '../../../comum/components/FormInputSimples'

@inject("store")
@observer
export default class FiltrosVisualizacaoAdicionar extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller

        this.state = {
            maisFiltros: false
        }

        this.filtros = this.filtros.bind(this)
        this.showFiltros = this.showFiltros.bind(this)
    }

    showFiltros() {
        this.setState({
            maisFiltros: !this.state.maisFiltros
        })
    }

    filtros() {
        return (
            <Row className="pb-0">
                <RadiobuttonGroup xs={12} sm={12} md={4} lg={4} xl={3}
                    titulo="Tipo de documento"
                    name="docType"
                    bloqueado={true}
                    //onClick={this.controller.setTipoDoc}
                    itens={[
                        { id: "DTC", value: "DTC", label: "DTC", checked: this.controller.dadosAdicao.tipoDoc === "DTC" },
                        { id: "DTA", value: "DTA", label: "DTA", checked: this.controller.dadosAdicao.tipoDoc === "DTA" }
                    ]}
                />
                <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                    <Label>Previsão de atracação</Label>
                    <CalendarioPicker
                        titulo="Previsão de atracação"
                        dataInicial={this.controller.dadosAdicao.dtInicial}
                        dataFinal={this.controller.dadosAdicao.dtFim}
                        bloqueado={true}
                    />
                </Col>
                <FormInputSimples  xs={12} sm={12} md={4} lg={4} xl={2}
                        titulo="Opereção"
                        dado={this.controller.dadosAdicao.operacao ? this.controller.dadosAdicao.operacao.label : ""}
                        bloqueado={true}
                    />
            </Row>
        )
    }

    render() {
        if(this.controller.listaAdicoes.length === 0) {
            return null
        } else {
            return (
                <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    {this.filtros()}
                </Card>
            </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/components/FiltrosVisualizacaoAdicionar.js